import { Button } from '@assembly-js/design-system';
import { useTranslation } from 'react-i18next';

export interface SettingsSaveBarProps {
  dirty: boolean;
  saving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export const SettingsSaveBar = ({
  dirty,
  saving,
  onSave,
  onCancel,
}: SettingsSaveBarProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex shrink-0 items-center gap-2">
      <Button
        variant="secondary"
        className="h-8 whitespace-nowrap"
        label={t(($) => $.common.cancel)}
        disabled={!dirty || saving}
        onClick={onCancel}
      />
      <Button
        className="h-8 whitespace-nowrap"
        label={t(($) => $.page_settings.save_bar.save_changes)}
        disabled={!dirty || saving}
        loading={saving}
        onClick={onSave}
      />
    </div>
  );
};
